import { render } from "./Nothing.vue?vue&type=template&id=0e00f3ce&scoped=true"
import script from "./Nothing.vue?vue&type=script&lang=ts"
export * from "./Nothing.vue?vue&type=script&lang=ts"

import "./Nothing.vue?vue&type=style&index=0&id=0e00f3ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e00f3ce"

export default script